(() => {
  if (window.socialSodaNavigationReady) return;
  window.socialSodaNavigationReady = true;
  window.webpackJsonp = window.webpackJsonp || [];
  window.webpackJsonp.push([['social-soda-runtime'], {
    'social-soda-bridge': function(module, exports, require) {
      window.socialSodaTheme = require('./src/assets/ts/utilities/Ohm/core/Ohm.ts').Ohm;
    }
  }, [['social-soda-bridge', 'flowerboy']]]);
  let pending;
  let sequence = 0;
  const flavorLink = target => target.closest('[data-social-flavors] a');
  const targetUrl = link => {
    const form = link.closest('form');
    const options = Array.from(form.querySelectorAll('input[name^="options["]:checked')).map(input => input.value);
    const variants = JSON.parse(link.dataset.flavorVariants);
    const variant = variants.find(item => item.options.length === options.length && item.options.every((option, index) => option === options[index]));
    const url = new URL(link.href);
    if (variant) url.searchParams.set('variant', variant.id);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      const value = new URL(location.href).searchParams.get(key);
      if (value !== null) url.searchParams.set(key, value);
    }
    return url;
  };
  const restorePurchase = (main, previous) => {
    const quantity = main.querySelector('[name="quantity"]');
    if (quantity) quantity.value = previous.quantity;
    if (previous.subscribe) {
      const radio = main.querySelector('[name="purchaseType"][value="purchaseTypeSubscription"]');
      if (radio) {
        const plan = main.querySelector('[name="selling_plan"]');
        const matching = plan && Array.from(plan.options).find(option => option.textContent.trim() === previous.planName);
        if (matching) plan.value = matching.value;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }
  };
  const navigate = async (url, push = true, focus = true) => {
    if (pending) pending.abort();
    const controller = new AbortController();
    pending = controller;
    const token = ++sequence;
    const main = document.querySelector('main#main');
    if (!main || !main.querySelector('[data-social-flavors]')) return;
    const previous = {
      quantity: main.querySelector('[name="quantity"]')?.value || '1',
      subscribe: main.querySelector('[name="purchaseType"]:checked')?.value === 'purchaseTypeSubscription',
      planName: main.querySelector('[name="selling_plan"] option:checked')?.textContent.trim()
    };
    const scroll = window.scrollY;
    main.setAttribute('aria-busy', 'true');
    main.classList.add('social-soda-loading');
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url.href, {credentials:'same-origin', signal:controller.signal});
      if (!response.ok) throw new Error('Unable to load this flavor');
      const html = await response.text();
      if (token !== sequence) return;
      const page = new DOMParser().parseFromString(html, 'text/html');
      const next = page.querySelector('main#main');
      if (!next?.querySelector('[data-social-flavors]')) throw new Error('Product template unavailable');
      window.socialSodaSubscriptionController?.abort();
      const scripts = Array.from(next.querySelectorAll('script')).filter(script => !script.src && (!script.type || script.type === 'text/javascript' || script.type === 'application/javascript'));
      scripts.forEach(script => script.remove());
      main.replaceChildren(...Array.from(next.childNodes));
      document.title = page.title;
      document.body.id = page.body.id;
      const canonical = document.querySelector('link[rel="canonical"]');
      const nextCanonical = page.querySelector('link[rel="canonical"]');
      if (canonical && nextCanonical) canonical.href = nextCanonical.href;
      const description = document.querySelector('meta[name="description"]');
      const nextDescription = page.querySelector('meta[name="description"]');
      if (description && nextDescription) description.content = nextDescription.content;
      if (push) history.pushState({...history.state, socialSoda:true}, '', url.href);
      for (const source of scripts) {
        if (source.textContent.includes("window.addEventListener('DOMContentLoaded'")) continue;
        const script = document.createElement('script');
        script.textContent = source.textContent;
        main.appendChild(script);
        script.remove();
      }
      if (!window.socialSodaTheme) throw new Error('Product controls unavailable');
      window.socialSodaTheme.update();
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if (token !== sequence) return;
      restorePurchase(main, previous);
      if (window.okeWidgetApi?.initAllWidgets) window.okeWidgetApi.initAllWidgets();
      document.dispatchEvent(new CustomEvent('social-soda:product-changed', {detail:{url:url.href}}));
      window.scrollTo({top:scroll, behavior:'instant'});
      if (focus) main.querySelector('[data-social-flavors] [aria-current="page"]')?.focus({preventScroll:true});
      const status = main.querySelector('[data-social-status]');
      if (status) status.textContent = main.querySelector('h1')?.textContent.trim() || '';
    } catch (error) {
      if (token !== sequence) return;
      location.assign(url.href);
    } finally {
      clearTimeout(timeout);
      if (token === sequence) {
        main.removeAttribute('aria-busy');
        main.classList.remove('social-soda-loading');
      }
    }
  };
  document.addEventListener('submit', event => {
    if (event.target.closest('main[aria-busy="true"]') && event.target.matches('form[action="/cart/add"]')) event.preventDefault();
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('main[aria-busy="true"] [add-to-cart]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', event => {
    const link = flavorLink(event.target);
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = targetUrl(link);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    if (url.pathname === location.pathname) return;
    navigate(url);
  });
  window.addEventListener('popstate', () => {
    if (new URL(location.href).searchParams.get('view') === 'm-social-soda' && document.querySelector('[data-social-flavors]')) {
      navigate(new URL(location.href), false, false);
    }
  });
})();
